// component
import SignUpPurchaseListCom from './sign-up-purchase-list/sign-up-purchase-list.vue';
import MarginPaymentCom from './margin-payment/margin-payment.vue';
import SignUpPurchaseDetailCom from './sign-up-purchase-detail/sign-up-purchase-detail.vue';

export default [
  {
    path: 'list',
    name: 'signUpPurchaseList',
    component: SignUpPurchaseListCom,
    meta: {
      title: '报名采购标的',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'margin-payment',
    name: 'marginPaymentCom',
    component: MarginPaymentCom,
    meta: {
      title: '支付保证金',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  },
  {
    path: 'detail',
    name: 'signUpPurchaseDetail',
    component: SignUpPurchaseDetailCom,
    meta: {
      title: '报名详情',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];

